import React, { useEffect, useState } from 'react';
import PieChart from './PieChart';
import styled from 'styled-components';
import { persistenceStats } from '@api/persistence';
import { formatData } from './utils';
import Summary from './Summary';

import { KeySelector, ProductSelector } from './ReportSelector';

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  padding: 2%;
`;

const PieWrapper = styled.div`
  display: flex;
  flex-direction: row;
`;

interface ReportDataInterface {
  dimensionsPie: [];
  metricsPie: [];
  summary: {};
}

function Report() {
  const [data, setData] = useState({
    dimensionsPie: [],
    metricsPie: [],
    summary: {},
  });
  const [productId, setProductId] = useState(1);
  const [persistenceKey, setPersistenceKey] = useState('/');
  const [loading, setLoading] = useState(true);

  const handleKeyChange = (value) => {
    setPersistenceKey(value);
  }

  const handleProductChange = (value) => {
    setProductId(value);
  }

  useEffect(() => {
    setLoading(true);
    async function getData() {
      const result = await persistenceStats({ key: persistenceKey, productId });
      if (result.data && result.data.data) {
        const formattedData = formatData(result.data.data);
        setData(formattedData as ReportDataInterface);
        setLoading(false);
      }
    }
    getData();
  }, [persistenceKey, productId]);

  if (loading) {
    return <Wrapper>Generating report...</Wrapper>;
  }

  return (
    <Wrapper>
      <h3>Persistence Report</h3>
      <ProductSelector handleChange={handleProductChange} selected={productId} />
      <KeySelector handleChange={handleKeyChange} selected={persistenceKey} />
      <Summary persistenceKey={persistenceKey} data={data.summary} />
      <PieWrapper>
        <PieChart data={data.dimensionsPie} title="Dimensions" />
        <PieChart data={data.metricsPie} title="Metrics" />
      </PieWrapper>
    </Wrapper>
  );
}

export default Report;
